import { THubCriminalAssessment } from '@/services/Hub/AssessmentsCriminal'
import { HubApi } from '@services'
import { AxiosError } from 'axios'
import { useCallback, useContext, useEffect, useState } from 'react'

import { ComplianceContext } from '../../providers/ComplianceContext'

export const useCriminalAssessment = (params: { personProfileId: string }) => {
  const [error, setError] = useState<AxiosError | null>()
  const [isRequesting, setIsRequesting] = useState(true)
  const [response, setResponse] = useState<THubCriminalAssessment>()
  const { numOfResets: resetCounter } = useContext(ComplianceContext)

  const resetStates = () => {
    setError(undefined)
    setIsRequesting(true)
    setResponse(undefined)
  }

  const fetchCriminalAssessmentApi = useCallback(async () => {
    try {
      const res = await HubApi.AssessmentsCriminal.getRequest(params.personProfileId)
      setResponse(res)
      setError(null)
    } catch (err) {
      if (err instanceof AxiosError) setError(err)
    } finally {
      setIsRequesting(false)
    }
  }, [params.personProfileId])

  useEffect(() => {
    resetStates()
    fetchCriminalAssessmentApi()
  }, [fetchCriminalAssessmentApi, resetCounter])

  return { response, isRequesting, error }
}
